import * as Types from '../../../generated/webapp_gql';

import { gql } from 'graphql.macro';
export type CircleSeriesFragment = (
  { __typename?: 'CircleSeriesNode' }
  & Pick<Types.CircleSeriesNode, 'id' | 'uuid' | 'slug' | 'name' | 'heroImage' | 'heroBackgroundColor' | 'description' | 'illustration' | 'shortDescription' | 'accessType'>
);

export type CircleRsvpQuestion_CircleCheckboxQuestionNode_Fragment = (
  { __typename: 'CircleCheckboxQuestionNode' }
  & Pick<Types.CircleCheckboxQuestionNode, 'questionText' | 'required' | 'id'>
);

export type CircleRsvpQuestion_CircleDropdownQuestionNode_Fragment = (
  { __typename: 'CircleDropdownQuestionNode' }
  & Pick<Types.CircleDropdownQuestionNode, 'questionText' | 'required' | 'id'>
  & { options: Array<(
    { __typename: 'CircleAnswerDropdownOptionNode' }
    & Pick<Types.CircleAnswerDropdownOptionNode, 'id' | 'optionText'>
  )> }
);

export type CircleRsvpQuestion_CircleParagraphQuestionNode_Fragment = (
  { __typename: 'CircleParagraphQuestionNode' }
  & Pick<Types.CircleParagraphQuestionNode, 'maxCharacters' | 'lines' | 'questionText' | 'required' | 'id'>
);

export type CircleRsvpQuestion_CircleRadioGroupQuestionNode_Fragment = (
  { __typename: 'CircleRadioGroupQuestionNode' }
  & Pick<Types.CircleRadioGroupQuestionNode, 'questionText' | 'required' | 'id'>
  & { options: Array<(
    { __typename: 'CircleAnswerRadioOptionNode' }
    & Pick<Types.CircleAnswerRadioOptionNode, 'id' | 'optionText'>
  )> }
);

export type CircleRsvpQuestion_CircleSingleLineQuestionNode_Fragment = (
  { __typename: 'CircleSingleLineQuestionNode' }
  & Pick<Types.CircleSingleLineQuestionNode, 'maxCharacters' | 'questionText' | 'required' | 'id'>
);

export type CircleRsvpQuestionFragment = CircleRsvpQuestion_CircleCheckboxQuestionNode_Fragment | CircleRsvpQuestion_CircleDropdownQuestionNode_Fragment | CircleRsvpQuestion_CircleParagraphQuestionNode_Fragment | CircleRsvpQuestion_CircleRadioGroupQuestionNode_Fragment | CircleRsvpQuestion_CircleSingleLineQuestionNode_Fragment;

export type CircleFacilitatorFragment = (
  { __typename?: 'CircleFacilitatorNode' }
  & Pick<Types.CircleFacilitatorNode, 'id' | 'photo' | 'name' | 'credential' | 'country'>
);

export type CircleTopicSessionFragment = (
  { __typename?: 'CircleSessionNode' }
  & Pick<Types.CircleSessionNode, 'id' | 'startTime' | 'seatsLeft' | 'rsvpLink' | 'useInHouseRsvp' | 'bookingStatus'>
  & { facilitators: Array<Types.Maybe<(
    { __typename?: 'CircleFacilitatorNode' }
    & CircleFacilitatorFragment
  )>> }
);

export type CircleTopicRsvpFragment = (
  { __typename?: 'CircleRsvpNode' }
  & { session: (
    { __typename?: 'CircleSessionNode' }
    & Pick<Types.CircleSessionNode, 'id'>
    & CircleTopicSessionFragment
  ) }
  & CircleRsvpBaseFragment
);

export type CircleTopicBaseFragment = (
  { __typename?: 'CircleTopicNode' }
  & Pick<Types.CircleTopicNode, 'id' | 'name' | 'uuid' | 'slug' | 'description' | 'note' | 'format' | 'duration'>
  & { rsvpQuestions: Array<Types.Maybe<(
    { __typename?: 'CircleCheckboxQuestionNode' }
    & CircleRsvpQuestion_CircleCheckboxQuestionNode_Fragment
  ) | (
    { __typename?: 'CircleDropdownQuestionNode' }
    & CircleRsvpQuestion_CircleDropdownQuestionNode_Fragment
  ) | (
    { __typename?: 'CircleParagraphQuestionNode' }
    & CircleRsvpQuestion_CircleParagraphQuestionNode_Fragment
  ) | (
    { __typename?: 'CircleRadioGroupQuestionNode' }
    & CircleRsvpQuestion_CircleRadioGroupQuestionNode_Fragment
  ) | (
    { __typename?: 'CircleSingleLineQuestionNode' }
    & CircleRsvpQuestion_CircleSingleLineQuestionNode_Fragment
  )>>, facilitators: (
    { __typename?: 'CircleFacilitatorConnection' }
    & Pick<Types.CircleFacilitatorConnection, 'totalCount'>
    & { edges: Array<Types.Maybe<(
      { __typename?: 'CircleFacilitatorEdge' }
      & Pick<Types.CircleFacilitatorEdge, 'cursor'>
      & { node: (
        { __typename?: 'CircleFacilitatorNode' }
        & CircleFacilitatorFragment
      ) }
    )>> }
  ), series: (
    { __typename?: 'CircleSeriesNode' }
    & Pick<Types.CircleSeriesNode, 'id' | 'uuid' | 'name' | 'slug' | 'accessType'>
  ) }
);

export type CircleTopicAuthenticatedFragment = (
  { __typename?: 'CircleTopicNode' }
  & { activeRsvps?: Types.Maybe<Array<(
    { __typename?: 'CircleRsvpNode' }
    & CircleTopicRsvpFragment
  )>>, sessions: (
    { __typename?: 'CircleSessionConnection' }
    & Pick<Types.CircleSessionConnection, 'totalCount'>
    & { edges: Array<Types.Maybe<(
      { __typename?: 'CircleSessionEdge' }
      & { node: (
        { __typename?: 'CircleSessionNode' }
        & CircleTopicSessionFragment
      ) }
    )>> }
  ) }
  & CircleTopicBaseFragment
);

export type CircleTopicFragment = (
  { __typename?: 'CircleTopicNode' }
  & { sessions: (
    { __typename?: 'CircleSessionConnection' }
    & Pick<Types.CircleSessionConnection, 'totalCount'>
    & { edges: Array<Types.Maybe<(
      { __typename?: 'CircleSessionEdge' }
      & { node: (
        { __typename?: 'CircleSessionNode' }
        & CircleTopicSessionFragment
      ) }
    )>> }
  ) }
  & CircleTopicBaseFragment
);

export type CircleSessionFragment = (
  { __typename?: 'CircleSessionNode' }
  & Pick<Types.CircleSessionNode, 'id' | 'uuid' | 'startTime' | 'rsvpLink' | 'seatsLeft' | 'useInHouseRsvp' | 'bookingStatus'>
  & { facilitators: Array<Types.Maybe<(
    { __typename?: 'CircleFacilitatorNode' }
    & CircleFacilitatorFragment
  )>>, topic: (
    { __typename?: 'CircleTopicNode' }
    & Pick<Types.CircleTopicNode, 'id' | 'format' | 'name' | 'slug' | 'duration'>
    & { series: (
      { __typename?: 'CircleSeriesNode' }
      & Pick<Types.CircleSeriesNode, 'id' | 'name' | 'slug' | 'accessType'>
    ) }
  ) }
);

export type CircleRsvpBaseFragment = (
  { __typename?: 'CircleRsvpNode' }
  & Pick<Types.CircleRsvpNode, 'id' | 'joinSessionUrl' | 'state'>
);

export type CircleRsvpFragment = (
  { __typename?: 'CircleRsvpNode' }
  & { session: (
    { __typename?: 'CircleSessionNode' }
    & Pick<Types.CircleSessionNode, 'id'>
    & CircleSessionFragment
  ) }
  & CircleRsvpBaseFragment
);

export const CircleSeriesFragmentDoc = gql`
    fragment CircleSeries on CircleSeriesNode {
  id
  uuid
  slug
  name
  heroImage
  heroBackgroundColor
  description
  illustration
  shortDescription
  accessType
}
    `;
export const CircleRsvpQuestionFragmentDoc = gql`
    fragment CircleRsvpQuestion on CircleBaseQuestion {
  __typename
  questionText
  required
  id
  ... on CircleCheckboxQuestionNode {
    __typename
  }
  ... on CircleDropdownQuestionNode {
    options {
      ... on CircleAnswerDropdownOptionNode {
        __typename
        id
        optionText
      }
    }
  }
  ... on CircleParagraphQuestionNode {
    maxCharacters
    lines
  }
  ... on CircleRadioGroupQuestionNode {
    options {
      ... on CircleAnswerRadioOptionNode {
        __typename
        id
        optionText
      }
    }
  }
  ... on CircleSingleLineQuestionNode {
    maxCharacters
  }
}
    `;
export const CircleFacilitatorFragmentDoc = gql`
    fragment CircleFacilitator on CircleFacilitatorNode {
  id
  photo
  name
  credential
  country
}
    `;
export const CircleTopicBaseFragmentDoc = gql`
    fragment CircleTopicBase on CircleTopicNode {
  id
  name
  uuid
  slug
  description
  note
  format
  duration
  rsvpQuestions {
    ...CircleRsvpQuestion
  }
  facilitators {
    totalCount
    edges {
      cursor
      node {
        ...CircleFacilitator
      }
    }
  }
  series {
    id
    uuid
    name
    slug
    accessType
  }
}
    ${CircleRsvpQuestionFragmentDoc}
${CircleFacilitatorFragmentDoc}`;
export const CircleRsvpBaseFragmentDoc = gql`
    fragment CircleRsvpBase on CircleRsvpNode {
  id
  joinSessionUrl
  state
}
    `;
export const CircleTopicSessionFragmentDoc = gql`
    fragment CircleTopicSession on CircleSessionNode {
  id
  startTime
  seatsLeft
  rsvpLink
  useInHouseRsvp
  bookingStatus
  facilitators {
    ...CircleFacilitator
  }
}
    ${CircleFacilitatorFragmentDoc}`;
export const CircleTopicRsvpFragmentDoc = gql`
    fragment CircleTopicRsvp on CircleRsvpNode {
  ...CircleRsvpBase
  session {
    id
    ...CircleTopicSession
  }
}
    ${CircleRsvpBaseFragmentDoc}
${CircleTopicSessionFragmentDoc}`;
export const CircleTopicAuthenticatedFragmentDoc = gql`
    fragment CircleTopicAuthenticated on CircleTopicNode {
  ...CircleTopicBase
  activeRsvps {
    ...CircleTopicRsvp
  }
  sessions(first: 100, excludeActiveRsvps: true) {
    totalCount
    edges {
      node {
        ...CircleTopicSession
      }
    }
  }
}
    ${CircleTopicBaseFragmentDoc}
${CircleTopicRsvpFragmentDoc}
${CircleTopicSessionFragmentDoc}`;
export const CircleTopicFragmentDoc = gql`
    fragment CircleTopic on CircleTopicNode {
  ...CircleTopicBase
  sessions(first: 100) {
    totalCount
    edges {
      node {
        ...CircleTopicSession
      }
    }
  }
}
    ${CircleTopicBaseFragmentDoc}
${CircleTopicSessionFragmentDoc}`;
export const CircleSessionFragmentDoc = gql`
    fragment CircleSession on CircleSessionNode {
  id
  uuid
  startTime
  rsvpLink
  seatsLeft
  useInHouseRsvp
  bookingStatus
  facilitators {
    ...CircleFacilitator
  }
  topic {
    id
    format
    name
    slug
    duration
    series {
      id
      name
      slug
      accessType
    }
  }
}
    ${CircleFacilitatorFragmentDoc}`;
export const CircleRsvpFragmentDoc = gql`
    fragment CircleRsvp on CircleRsvpNode {
  ...CircleRsvpBase
  session {
    id
    ...CircleSession
  }
}
    ${CircleRsvpBaseFragmentDoc}
${CircleSessionFragmentDoc}`;